import React from 'react';

import { ClickableIcon } from '~components';
import { faEye } from '~components/icon';

import { PaymentBatch } from '~direct-debits/models';

interface ComponentProps {
  row: PaymentBatch;
  onSelectBatch?: (batchId: string) => void;
}

// Row actions across the app are icons with a tooltip rather than in-row text
// links - see BatchClientRowAction for the level-2 equivalent. The wrapper
// keeps the icon flush with the right-aligned actions column.
const PaymentBatchRowAction: React.FC<ComponentProps> = ({ row, onSelectBatch }) => (
  <div className="d-flex gap-2 justify-content-end align-items-center">
    <ClickableIcon
      id={`dd-payment-batch-view-${row.id}`}
      dataCy={`dd-payment-batches-view-${row.id}`}
      icon={faEye}
      toolTip="View Details"
      ariaLabel="View Details"
      disabled={!onSelectBatch}
      onClick={() => onSelectBatch?.(row.id)}
    />
  </div>
);

export default PaymentBatchRowAction;
